// extracted by mini-css-extract-plugin
export default {"wrap":"fa-z","heading":"ga-z","formError":"ha-z"};